import React from 'react';
import { Select, Space } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';

const { Option } = Select;

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (value: string) => {
    i18n.changeLanguage(value);
  };

  const languages = [
    
    { code: 'en-US', name: 'English', flag: '🇺🇸' },
    { code: 'zh-CN', name: '中文简体', flag: '🇨🇳' },
    { code: 'zh-TW', name: '繁体中文', flag: '🇨🇳' },
    { code: 'ja-JP', name: '日本語', flag: '🇯🇵' },
    { code: 'ko-KR', name: '한국인', flag: '🇰🇷' },
    { code: 'vi-VN', name: 'Tiếng Việt', flag: '🇻🇳'}
  ];

  return (
    <Space>
      <GlobalOutlined className={styles.globalIcon} />
      <Select
        value={i18n.language}
        onChange={handleLanguageChange}
        className={styles.selectList}
        
        variant="borderless"
      >
        
        {languages.map(lang => (
          <Option key={lang.code} value={lang.code}>
            <Space className={styles.selectText}>
              <span>{lang.flag}</span>
              <span>{lang.name}</span>
            </Space>
          </Option>
        ))}
      </Select>
    </Space>
  );
};

export default LanguageSwitcher;